module.exports = __webpack_public_path__ + "static/muscle-workout-01-7323a11e6fc665455d61ca8b9fb8da92.jpg";